/* shop/components/ThankYou.svelte generated by Svelte v3.59.2 */
import {
	SvelteComponentDev,
	add_location,
	append_dev,
	attr_dev,
	detach_dev,
	dispatch_dev,
	element,
	empty,
	init,
	insert_dev,
	noop,
	safe_not_equal,
	space,
	text,
	validate_slots
} from "svelte/internal";

const file = "shop/components/ThankYou.svelte";

// (15:0) {#if order && order.online_payment_url}
function create_if_block(ctx) {
	let div;
	let a;
	let t;
	let a_href_value;

	const block = {
		c: function create() {
			div = element("div");
			a = element("a");
			t = text("Zaplatit");
			attr_dev(a, "href", a_href_value = /*order*/ ctx[0].online_payment_url);
			attr_dev(a, "class", "basketButton");
			add_location(a, file, 16, 8, 292);
			attr_dev(div, "class", "basketButtonWrap");
			add_location(div, file, 15, 4, 253);
		},
		m: function mount(target, anchor) {
			insert_dev(target, div, anchor);
			append_dev(div, a);
			append_dev(a, t);
		},
		p: function update(ctx, dirty) {
			if (dirty & /*order*/ 1 && a_href_value !== (a_href_value = /*order*/ ctx[0].online_payment_url)) {
				attr_dev(a, "href", a_href_value);
			}
		},
		d: function destroy(detaching) {
			if (detaching) detach_dev(div);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block.name,
		type: "if",
		source: "(15:0) {#if order && order.online_payment_url}",
		ctx
	});

	return block;
}

function create_fragment(ctx) {
	let h1;
	let t0;
	let br;
	let t1;
	let t2;
	let if_block_anchor;
	let if_block = /*order*/ ctx[0] && /*order*/ ctx[0].online_payment_url && create_if_block(ctx);

	const block = {
		c: function create() {
			h1 = element("h1");
			t0 = text("Děkujeme");
			br = element("br");
			t1 = text("Vaše obejdnávka byla uložena.");
			t2 = space();
			if (if_block) if_block.c();
			if_block_anchor = empty();
			add_location(br, file, 13, 12, 170);
			add_location(h1, file, 13, 0, 158);
		},
		l: function claim(nodes) {
			throw new Error("options.hydrate only works if the component was compiled with the `hydratable: true` option");
		},
		m: function mount(target, anchor) {
			insert_dev(target, h1, anchor);
			append_dev(h1, t0);
			append_dev(h1, br);
			append_dev(h1, t1);
			insert_dev(target, t2, anchor);
			if (if_block) if_block.m(target, anchor);
			insert_dev(target, if_block_anchor, anchor);
		},
		p: function update(ctx, [dirty]) {
			if (/*order*/ ctx[0] && /*order*/ ctx[0].online_payment_url) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}
		},
		i: noop,
		o: noop,
		d: function destroy(detaching) {
			if (detaching) detach_dev(h1);
			if (detaching) detach_dev(t2);
			if (if_block) if_block.d(detaching);
			if (detaching) detach_dev(if_block_anchor);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_fragment.name,
		type: "component",
		source: "",
		ctx
	});

	return block;
}

function instance($$self, $$props, $$invalidate) {
	let { $$slots: slots = {}, $$scope } = $$props;
	validate_slots('ThankYou', slots, []);
	let { order } = $$props;

	$$self.$$.on_mount.push(function () {
		if (order === undefined && !('order' in $$props || $$self.$$.bound[$$self.$$.props['order']])) {
			console.warn("<ThankYou> was created without expected prop 'order'");
		}
	});

	const writable_props = ['order'];

	Object.keys($$props).forEach(key => {
		if (!~writable_props.indexOf(key) && key.slice(0, 2) !== '$$' && key !== 'slot') console.warn(`<ThankYou> was created with unknown prop '${key}'`);
	});

	$$self.$$set = $$props => {
		if ('order' in $$props) $$invalidate(0, order = $$props.order);
	};

	$$self.$capture_state = () => ({ order });

	$$self.$inject_state = $$props => {
		if ('order' in $$props) $$invalidate(0, order = $$props.order);
	};

	if ($$props && "$$inject" in $$props) {
		$$self.$inject_state($$props.$$inject);
	}

	return [order];
}

class ThankYou extends SvelteComponentDev {
	constructor(options) {
		super(options);
		init(this, options, instance, create_fragment, safe_not_equal, { order: 0 });

		dispatch_dev("SvelteRegisterComponent", {
			component: this,
			tagName: "ThankYou",
			options,
			id: create_fragment.name
		});
	}

	get order() {
		throw new Error("<ThankYou>: Props cannot be read directly from the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	set order(value) {
		throw new Error("<ThankYou>: Props cannot be set directly on the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}
}

export default ThankYou;